import { render, staticRenderFns } from "./FlightInfoPax.vue?vue&type=template&id=f5602192"
import script from "./FlightInfoPax.vue?vue&type=script&lang=js"
export * from "./FlightInfoPax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports